// router.js
import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import Profile from '../views/UserProfile.vue';
import CompetitionsList from '../views/competitions/CompetitionsList.vue';
import AthletesList from '../views/athletes/AthletesList.vue';
import JudgesList from '../views/judges/JudgesList.vue';
import OrganizerList from '../views/organizer/OrganizerList.vue';
import CompetitionsCU from "@/views/competitions/CompetitionsCU.vue";
import CompetitionWizardAssistant from "@/views/competitions/CompetitionWizardAssistant.vue";
import CompetitionsView from "@/views/competitions/CompetitionsView.vue";
import CompetitionDetails from '../views/CompetitionDetailsView.vue';
import TrainingView from '../views/training/TrainingView.vue';
import RulesBooksView from '../views/rules_books/RulesBooksView.vue';
import Judging from '../views/JudgingProgramView.vue';
import ScoreProgram from '../views/ScoreProgram.vue';
import Statistics from '../views/StatisticsView.vue';
import TrickList from '../views/TrickListView.vue';
import TrickListCsvSyncView from '../views/TrickListCsvSyncView.vue';
import Notifications from '../views/NotificationsView.vue';
import AuthComponent from '../services/AuthComponent.vue';
import ForgotPassword from '../components/app/ForgotPassword.vue';
import ForgotPasswordReset from '../components/app/ForgotPasswordReset.vue';
import ConfirmSanitization from '../components/app/ConfirmSanitization.vue';
import TimerCodeView from '../views/TimerCodeView.vue';
import LegalDocumentView from '../views/legal/LegalDocumentView.vue';
import store from '../store';
import { isSupervisor } from '@/helpers/roleUtils';

const routes = [
    { path: '/', component: AuthComponent },
    { path: '/home', component: Home, meta: { requiresAuth: true } },
    { path: '/judging', component: Judging, meta: { requiresAuth: true } },
    { path: '/score', component: ScoreProgram, meta: { requiresAuth: true } },
    { path: '/statistics', component: Statistics, meta: { requiresAuth: true } },
    { path: '/trickList', component: TrickList, meta: { requiresAuth: true } },
    { path: '/trickList/csv-sync', component: TrickListCsvSyncView, meta: { requiresAuth: true, supervisorOnly: true } },
    { path: '/notifications', component: Notifications, meta: { requiresAuth: true } },
    { path: '/rulebooks', component: RulesBooksView, meta: { requiresAuth: true } },
    { path: '/profile', component: Profile, meta: { requiresAuth: true } },
    { path: '/profile/:id?', component: Profile, meta: { requiresAuth: true } },
    { path: '/competitions', component: CompetitionsList, meta: { requiresAuth: true } },
    { path: '/competition/assistant', component: CompetitionWizardAssistant, meta: { requiresAuth: true } },
    { path: '/competition', component: CompetitionsCU, meta: { requiresAuth: true } },
    { path: '/competitionView', component: CompetitionsView, meta: { requiresAuth: true } },
    { path: '/competitionDetails', component: CompetitionDetails, meta: { requiresAuth: true } },
    { path: '/athletes', component: AthletesList, meta: { requiresAuth: true } },
    { path: '/judges', component: JudgesList, meta: { requiresAuth: true } },
    { path: '/organizer', component: OrganizerList, meta: { requiresAuth: true } },
    { path: '/training', component: TrainingView, meta: { requiresAuth: true } },
    {
        path: '/supervisor/management',
        name: 'SupervisorManagement',
        component: () => import('@/views/management/ManagementView.vue'),
        meta: { requiresAuth: true, supervisorOnly: true }
    },
    { path: '/forgot-password', component: ForgotPassword, meta: { requiresAuth: false } },
    { path: '/forgot-password/:token', component: ForgotPasswordReset, meta: { requiresAuth: false } },
    { path: '/confirm-sanitization/:token', component: ConfirmSanitization, meta: { requiresAuth: false } },
    { path: '/timer-code/:accessCode', component: TimerCodeView, meta: { requiresAuth: false } },
    { path: '/legal/:document', component: LegalDocumentView, meta: { requiresAuth: false } },

];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['user/isAuthenticated'];
    const user = store.getters['user/getUser'];

    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        next({ path: "/" }); // Redirige al login si no está autenticado
        return;
    }

    if (isAuthenticated && to.path === "/") {
        next({ path: "/home" }); // Si está autenticado y va al login, mandarlo a home
        return;
    }

    if (to.matched.some(record => record.meta.supervisorOnly) && !isSupervisor(user)) {
        next({ path: "/home" });
        return;
    }

    next(); // Permitir navegación normal
});

export default router;
